<template>
  <div class="container">
    <div class="header">
      <div class="logo"><i class="fas fa-box"></i></div>
      <h1>回寄采集盒</h1>
      <p class="subtitle">请填写回寄信息，我们将尽快安排取件</p>
    </div>

    <div class="content">
      <div v-if="currentView === 'form'">
        <div class="form-title"><i class="fas fa-truck"></i> 回寄信息填写</div>

        <div class="section-title">收件信息</div>
        <div class="form-group">
          <label>收件人</label>
          <input type="text" v-model="formData.recipient" readonly>
        </div>
        <div class="form-group">
          <label>收件地址</label>
          <textarea v-model="formData.recipientAddress" readonly></textarea>
        </div>

        <div class="section-title">寄件信息</div>
        <div class="form-group">
          <label>寄件人</label>
          <input type="text" v-model="formData.sender" placeholder="请输入寄件人姓名">
        </div>
        <div class="form-group">
          <label>手机号</label>
          <input type="tel" v-model="formData.phone" placeholder="请输入手机号码">
        </div>
        <div class="form-group">
          <label>寄件地址</label>
          <textarea v-model="formData.senderAddress" placeholder="请输入详细的寄件地址"></textarea>
        </div>

        <div class="form-group">
          <label>汇集的采集盒</label>
          <select v-model="formData.selectedBox">
            <option value="">请选择要回寄的采集盒</option>
            <option v-for="box in availableBoxes" :key="box.id" :value="box.id">{{ box.number }} - {{ box.name }}</option>
          </select>
          <div class="box-list">
            <div v-for="box in availableBoxes" :key="box.id" class="box-item" :class="{ selected: formData.selectedBox === box.id }" @click="formData.selectedBox = box.id">
              <div class="box-number">{{ box.number }}</div>
              <div class="box-status">{{ box.name }}</div>
            </div>
          </div>
        </div>

        <button class="btn" @click="submitForm"><i class="fas fa-paper-plane"></i> 提交</button>
      </div>

      <div class="result-container" v-else>
        <div class="result-icon success"><i class="fas fa-check-circle"></i></div>
        <h2 class="result-title">提交成功！</h2>
        <p class="result-message">回寄申请已提交成功，快递员将在24小时内联系您取件</p>
        <button class="btn" @click="$router.push('/mine')"><i class="fas fa-home"></i> 返回首页</button>
      </div>
    </div>

    <div class="footer">
      <p>© 2023 爱乐存 | 智能存储解决方案</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReturnBox',
  data () {
    return {
      currentView: 'form',
      formData: {
        recipient: '爱乐存服务中心 13333333333',
        recipientAddress: '北京市海淀区中关村南大街5号\n爱乐存收件中心 邮编：100081',
        sender: '',
        phone: '',
        senderAddress: '',
        selectedBox: ''
      },
      availableBoxes: [
        { id: '1', number: 'RY-20231015-001', name: '乳牙采集盒' },
        { id: '2', number: 'RY-20231020-002', name: '乳牙采集盒' },
        { id: '3', number: 'RY-20231025-003', name: '乳牙采集盒' },
        { id: '4', number: 'RY-20231101-004', name: '乳牙采集盒' }
      ]
    }
  },
  methods: {
    submitForm () {
      if (!this.formData.sender) return alert('请输入寄件人姓名')
      if (!this.formData.phone) return alert('请输入手机号码')
      if (!this.formData.senderAddress) return alert('请输入寄件地址')
      if (!this.formData.selectedBox) return alert('请选择要回寄的采集盒')
      this.currentView = 'success'
    }
  }
}
</script>

<style scoped>
.container {   margin: 0 auto ; background: white; border-radius: 20px; overflow: auto; box-shadow: 0 10px 30px rgba(0,0,0,0.15); }
.header { text-align: center; padding: 30px 20px; background: linear-gradient(45deg, #3498db 0%, #2ecc71 100%); color: white; }
.logo { width: 80px; height: 80px; border-radius: 50%; background: rgba(255,255,255,0.2); margin: 0 auto 15px; display: flex; align-items: center; justify-content: center; font-size: 36px; }
h1 { font-size: 28px; margin-bottom: 10px; }
.subtitle { font-size: 16px; opacity: 0.9; }
.content { padding: 25px 20px; }
.form-title { font-size: 20px; margin-bottom: 20px; color: #3498db; display: flex; align-items: center; border-bottom: 2px solid #eee; padding-bottom: 10px; }
.form-title i { margin-right: 10px; color: #2ecc71; }
.section-title { font-size: 18px; margin: 25px 0 15px; color: #2c3e50; padding-left: 10px; border-left: 4px solid #3498db; }
.form-group { margin-bottom: 20px; }
.form-group label { display: block; margin-bottom: 8px; font-weight: 500; color: #555; }
.form-group input, .form-group select, .form-group textarea { width: 100%; padding: 14px; border: 1px solid #ddd; border-radius: 8px; font-size: 16px; transition: all 0.3s; }
.form-group input:read-only { background-color: #f8f9fa; color: #6c757d; }
.form-group input:focus, .form-group select:focus, .form-group textarea:focus { border-color: #3498db; outline: none; box-shadow: 0 0 0 3px rgba(52,152,219,0.1); }
.form-group textarea { min-height: 80px; resize: vertical; }
.btn { background: linear-gradient(45deg, #3498db 0%, #2ecc71 100%); color: white; border: none; padding: 16px; border-radius: 10px; font-size: 18px; font-weight: 500; cursor: pointer; width: 100%; margin-top: 10px; transition: all 0.3s; }
.btn:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(0,0,0,0.2); }
.btn:active { transform: translateY(0); }
.result-container { text-align: center; padding: 40px 20px; }
.result-icon { font-size: 80px; margin-bottom: 20px; }
.success { color: #2ecc71; }
.result-title { font-size: 24px; margin-bottom: 15px; color: #2c3e50; }
.result-message { font-size: 16px; color: #7f8c8d; margin-bottom: 30px; }
.footer { text-align: center; padding: 20px; color: #95a5a6; background: #f8f9fa; border-top: 1px solid #eee; }
.box-list { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 10px; margin-top: 10px; }
.box-item { border: 2px solid #ddd; border-radius: 8px; padding: 10px; text-align: center; cursor: pointer; transition: all 0.3s; }
.box-item:hover { border-color: #3498db; background-color: #f8f9ff; }
.box-item.selected { border-color: #2ecc71; background-color: #e8f5e8; }
.box-number { font-weight: bold; color: #2c3e50; }
.box-status { font-size: 12px; color: #7f8c8d; }
</style>
